import { render, staticRenderFns } from "./CashbackDetailsContainer.vue?vue&type=template&id=5f0b18c0&scoped=true"
import script from "./CashbackDetailsContainer.vue?vue&type=script&lang=js"
export * from "./CashbackDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./CashbackDetailsContainer.vue?vue&type=style&index=0&id=5f0b18c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b18c0",
  null
  
)

export default component.exports